
export const eventNameTranslator = (ruleMergedEventLog) => 
    ruleMergedEventLog
    &&
    ruleMergedEventLog.io
    &&
    ruleMergedEventLog.rule?.name_violated
    ||
    ruleMergedEventLog.name_violated
    ||
    ruleMergedEventLog.rule?.name_complied
    ||
    ruleMergedEventLog.name_complied
    ||
    ruleMergedEventLog.rule?.name
    || 
    ruleMergedEventLog.name